import General from '../components/General.js';
import Introduction from './Films/Introduction/Introduction.js';
import BodyOfWork from './Films/BodyOfWork/BodyOfWork.js';
import Economics from './Films/EconomicsOfCinema/Economics.js';
import { Box, Stack, Text } from '@chakra-ui/react';
import { useParams, useLocation, useNavigate } from 'react-router-dom';
import { getFilmPrimaryData } from '../services/Films.js';
import { useEffect, useMemo, useState } from 'react';
import Basic from '../components/Primary.js';
import Preface from './Films/Introduction/Preface.js';
import Specifications from './Films/Introduction/Specifications.js';
import Editorial from './Films/BodyOfWork/Editorial.js';
import Synopsis from './Films/BodyOfWork/Synopsis.js';
import CreditsCasts from './Films/BodyOfWork/CreditsCasts.js';
import WatchFilm from './Films/BodyOfWork/WatchFilm.js';
import LyricsTracks from './Films/BodyOfWork/LyricsTracks.js';
import Screenings from './Films/EconomicsOfCinema/Screenings.js';
import Awards from './Films/EconomicsOfCinema/Awards.js';
import MyTabsNested from '../components/MyTabsNested.js';
import { useSelector } from 'react-redux';
import MyAccordionNested from '../components/MyAccordionNested.js';
import Sections from '../CommonComponents/Sections.js';
import ResearchCentre from '../FunctionalComponents/ResearchCentre/ResearchCentre.js';
import Library from '../FunctionalComponents/ResearchCentre/Library.js';
import Archive from '../FunctionalComponents/ResearchCentre/Archive.js';

const EditFilmRecord = () => {
  const { alias } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const [filmTitle, setFilmTitle] = useState();
  const previewEnabled = useSelector(state => state.preview.isEnabled);

  const tabs = useMemo(() => [
    {
      id: "general",
      title: "General",
      Component: General, // Using enhanced component
      subTabs: [
        { id: "primary", title: "Primary", Component: Basic },
        { id: "sections", title: "Sections", Component: Sections },
      ]
    },
    {
      id: "introduction",
      title: "Introduction",
      Component: Introduction,
      subTabs: [
        { id: "preface", title: "Preface", Component: Preface },
        { id: "specifications", title: "Specifications", Component: Specifications },
      ]
    },
    {
      id:"research-centre",
      title: "Research Centre",
      Component: ResearchCentre,
      subTabs: [
        { id: "library", title: "Library", Component: Library },
        { id: "archive", title: "Archive", Component: Archive },
      ]
    },
    {
      id: "body-of-work",
      title: "Body Of Work",
      Component: BodyOfWork,
      subTabs: [
        { id: "editorial", title: "Editorial", Component: Editorial },
        { id: "synopsis", title: "Synopsis", Component: Synopsis },
        { id: "credit-cast", title: "Credits & Casts", Component: CreditsCasts },
        { id: "lyrics-soundtrack", title: "Lyrics & Sound Tracks", Component: LyricsTracks },
        { id: "watch-fullfilm", title: "Watch Full Film", Component: WatchFilm },
      ]
    },
    {
      id: "economics-of-cinema",
      title: "Economics of Cinema",
      Component: Economics,
      subTabs: [
        { id: "screenings", title: "Screenings", Component: Screenings },
        { id: "awards-and-honours", title: "Awards and Honours", Component: Awards },
      ]
    },
  ], []);

  // Get film data
  useEffect(() => {
    const getBasicData = async () => {
      try {
        if (alias) {
          const result = await getFilmPrimaryData(alias);
          if (result) {
            setFilmTitle(result?.title);
          }
        }
      } catch (error) {
        console.error('Error fetching film data:', error);
      }
    };
    getBasicData();
  }, [alias]);

  // Redirect to default tab if no tab is specified
  useEffect(() => {
    const pathParts = location.pathname.split('/');
    if (pathParts?.length === 3 && alias) {
      // Redirect to the default tab/subTab
      navigate(`/film/${alias}/agraphy/${tabs[0].id}/${tabs[0].subTabs[0].id}`, { replace: true });
    }
  }, [location.pathname, alias, navigate, tabs]);

  return (
    <Stack px="1rem" pb={'1rem'} width={"100%"}>
     <Box>
       <Text fontSize={"18px"} pt={2} fontWeight={"600"}>{filmTitle}</Text>
     </Box>
      {previewEnabled ?
        <MyAccordionNested orientation="vertical" list={tabs} urlBasePath="/film" tabSegmentPosition={3} subTabSegmentPosition={4} includeAgraphy /> :
        <MyTabsNested orientation="vertical" list={tabs} urlBasePath="/film" tabSegmentPosition={3} subTabSegmentPosition={4} includeAgraphy />}
    </Stack>
  );
};

export default EditFilmRecord;